/**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return (value && typeof value == 'object') || false;
}

module.exports = isObjectLike;



//////////////////
// WEBPACK FOOTER
// ./~/xmlbuilder/~/lodash/internal/isObjectLike.js
// module id = 63
// module chunks = 1